<template>
    <Head title="Вхід"/>
    <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
        <div class="w-full max-w-md">
            <Link :href="$route('index')">
                <logo class="block mx-auto w-full max-w-xs fill-white" height="50"/>
            </Link>
            <div v-if="$page.props.flash.success" class="p-4 mb-4 text-green-700 bg-green-100 rounded-lg">
                {{ $page.props.flash.success }}
            </div>
            <div v-if="$page.props.errors.otp" class="p-4 mb-4 text-red-700 bg-red-100 rounded-lg">
                {{ $page.props.errors.otp }}
            </div>
            <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
                <div class="px-10 py-12">
                    <h1 class="text-center text-3xl font-bold">Ласкаво просимо!</h1>
                    <div class="mt-6 mx-auto w-24 border-b-2"/>
                    <text-input v-model="form.phone_number" :error="form.errors.phone_number" class="mt-10"
                                label="Номер телефону" type="text" autofocus autocapitalize="off"/>
                    <button
                        type="button"
                        class="mt-6 btn-indigo"
                        @click.prevent="sendOtp"
                    >
                        Запросити пароль
                    </button>
                    <text-input
                        v-model="form.otp"
                        :error="form.errors.otp"
                        class="mt-6"
                        label="Пароль з смс"
                        type="text"
                    />
                </div>
                <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
                    <loading-button
                        :loading="form.processing"
                        type="button"
                        class="btn-indigo ml-auto"
                        @click.prevent="verifyOtp"
                    >
                        Увійти
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        LoadingButton,
        Logo,
        TextInput,
        Link
    },
    data() {
        return {
            form: this.$inertia.form({
                phone_number: '',
                otp: '',
            }),
        }
    },
    methods: {
        sendOtp() {
            this.form.post('/send-otp', {phone_number: this.form.phone_number})
        },
        verifyOtp() {
            this.form.post('/verify-otp', {phone_number: this.form.phone_number, otp: this.form.otp})
        },
    },
}
</script>
